import { keepPreviousData, MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError, HTTP } from './lib/http.js';

/* Singleton do TanStack Query (transporte REST tipado, ADR-0354/0699).

   Hidratação (ADR-0699): `staleTime` 30s evita refetch a cada navegação (a SPA passa a
   ter benefício de cache entre telas); `placeholderData: keepPreviousData` mantém o
   last-good data durante troca de filtro/aba/página (fim do flash de spinner); `retry`
   não re-tenta 4xx (erro determinístico aparece na hora). Interceptor global: qualquer
   query/mutation que retorne 401 (sessão expirada no meio do uso) limpa a sessão e manda
   ao /login — em vez de "erro genérico" até a próxima navegação. */

let onSessionExpired: (() => void) | undefined;

/** Registrado no boot (main.tsx) após o router existir — evita ciclo query-client↔router. */
export function setSessionExpiredHandler(handler: () => void): void {
  onSessionExpired = handler;
}

function handleGlobalError(error: unknown): void {
  if (error instanceof ApiError && error.status === HTTP.unauthorized) {
    onSessionExpired?.();
  }
}

const RETRY_MAX = 1;
const CLIENT_ERROR_MIN = 400;
const CLIENT_ERROR_MAX = 500;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleGlobalError }),
  mutationCache: new MutationCache({ onError: handleGlobalError }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
      retry: (count, error) => {
        if (
          error instanceof ApiError &&
          error.status >= CLIENT_ERROR_MIN &&
          error.status < CLIENT_ERROR_MAX
        ) {
          return false;
        }
        return count < RETRY_MAX;
      },
    },
  },
});
